<template>

  <v-container
    v-if="policy"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title v-once>
        {{policy.name || 'Create'}}
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="policy.name" class="ma-1" label="Nume" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="policy.static.refundable"
              :items="[ {value: false, text: 'Nerambursabil'}, {value: true, text: 'Rambursabil'} ]"
              :value="false"
              label="Tip"
              class="ma-1"
              outlined dense hide-details
            />
          </v-col>
          <v-col cols="12" v-if="policy.static.refundable">
            <v-select
              v-model="partial"
              :items="[ {value: false, text: 'Completă'}, {value: true, text: 'Partială'} ]"
              :value="false"
              label="Rambursabilitate"
              @change="updatePartial"
              class="ma-1"
              outlined dense hide-details
            />
          </v-col>

          <v-col cols="12" v-if="policy.static.refundable && partial">
            <div class="subtitle-1 font-weight-black ma-1">Reguli de penalizare</div>
          </v-col>
          <v-col cols="12" v-if="policy.static.refundable && partial">
            <div class="ma-n1">
              <im-policy-rule-card
                v-for="(rule, index) in policy.rules"
                :key="`rule_${index}`"
                :index="index"
                :rule="rule"
                @remove="removeRule(rule)"
              />
            </div>

          </v-col>

          <v-col cols="12" class="text-right" v-if="policy.static.refundable && partial">
            <v-btn depressed color="success" class="ma-1" @click="addRule()" :disabled="policy.rules.length >= 5">
              <v-icon>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="policy.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>


<script>

  import default_policy from '@/defaults/default-policy'
  import policy_repository from '@/repositories/policy-repository'

  export default {

    components: {
      'im-policy-rule-card': () => import('@/components/PolicyCancellation/CancellationPolicyRuleCard')
    },

    data: () => ({
      policy: null,
      partial: false,
      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    async created() {
      this.policy = (this.$route.params.policy === 'create') ? _.cloneDeep(default_policy) : await policy_repository.getCancellationPolicy(this.$route.params.hotel, this.$route.params.policy);
      this.partial = this.policy.rules.length > 0;
    },

    methods: {

      async save() {
        try {
          this.saving = true;
          this.policy = await policy_repository.savePolicy(this.$route.params.hotel, this.policy);
          await this.$store.dispatch('alert/success', 'Success');
          this.$route.params.policy === 'create' ?  await this.$router.push(`/hotels/${this.$route.params.hotel}/cancellation-policies/${this.policy.id}`) : null;
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await policy_repository.destroyPolicy(this.$route.params.hotel, this.policy.id);
          await this.$router.push(`/hotels/${this.$route.params.hotel}/cancellation-policies`);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      addRule() {
        this.policy.rules.push({
          interval_value: 1,
          interval_type: 'days-until-check-in',
          penalty_value: 1,
          penalty_type: 'percent'
        });
      },

      removeRule(rule) {
        this.policy.rules.splice(this.policy.rules.indexOf(rule), 1);
      },

      updatePartial() {
        if (!this.partial)
          this.policy.rules = [];
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }

    }

  }

</script>